<template>
  <div
    class="card card-absolute rfo-card oa-section-card oa-commit"
    :class="{ 'oa-commit--warning': hasExistingPayment }"
  >
    <div class="card-header bg-secondary text-white">
      <h5 class="mb-0"><i class="fa fa-check-square-o me-2"></i>Review And Send</h5>
    </div>
    <div class="card-body">
      <div v-if="hasExistingPayment" class="alert alert-warning outline mb-3">
        <strong
          ><i class="fa fa-exclamation-triangle me-2"></i>Existing payment will be replaced</strong
        >
        <div class="small mt-1">
          Current payment status: <code>{{ existingPaymentStatus }}</code>
        </div>
        <div class="form-check mt-2 mb-0">
          <input
            id="ackOverwrite"
            :checked="acknowledgeOverwrite"
            type="checkbox"
            class="form-check-input border border-primary"
            @change="onAcknowledgeChange"
          /><label class="form-check-label small" for="ackOverwrite"
            >I understand the existing payment will be replaced.</label
          >
        </div>
      </div>
      <div v-if="submitError" class="alert alert-danger outline small mb-3">
        <i class="fa fa-exclamation-circle me-1"></i>{{ submitError }}
      </div>
      <div class="oa-commit__footer">
        <button type="button" class="btn btn-outline-secondary" @click="$emit('cancel')">
          <i class="fa fa-arrow-left me-1"></i>Cancel
        </button>
        <span v-if="submitBlockerMessage && !isSubmitting" class="oa-commit__blocker"
          ><i class="fa fa-info-circle me-1"></i>{{ submitBlockerMessage }}</span
        >
        <button
          type="button"
          class="btn btn-success text-white oa-commit__send"
          :disabled="!canSubmit"
          @click="$emit('submit')"
        >
          <span v-if="isSubmitting"
            ><span class="spinner-border spinner-border-sm me-1"></span>Sending to Odoo...</span
          ><span v-else><i class="fa fa-paper-plane me-2"></i>Send Payment To Odoo</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  hasExistingPayment: boolean;
  existingPaymentStatus: string;
  acknowledgeOverwrite: boolean;
  submitError: string;
  submitBlockerMessage: string;
  isSubmitting: boolean;
  canSubmit: boolean;
}>();
const emit = defineEmits(['update:acknowledgeOverwrite', 'cancel', 'submit']);

function onAcknowledgeChange(event: Event) {
  emit('update:acknowledgeOverwrite', (event.target as HTMLInputElement).checked);
}
</script>

<style scoped>
.oa-commit {
  border-color: #b6ccfe;
}
.oa-commit--warning {
  border-color: #fedf89;
}
.oa-commit__footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}
.oa-commit__blocker {
  color: #667085;
  font-size: 0.78rem;
}
.oa-commit__send {
  min-width: 14rem;
  margin-left: auto;
  font-weight: 700;
}
</style>
